import React, {useEffect} from 'react';
import $ from "../../utils/datatables";
import {Link} from "react-router-dom";
import moment from "moment";
import { toast } from 'react-toastify';
import {GET_PRESEASON_CONTRACTS_URL} from "../../api";

const PreSeasonContract = (props) => {

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#preseason_contract_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Loading preseason contracts</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                $.ajax(`${GET_PRESEASON_CONTRACTS_URL}`, {
                    type: 'GET',
                    headers: {
                        Authorization: token
                    },
                    success: function(res) {
                        const rawList = Array.isArray(res) ? res : (res?.results ?? res?.data ?? []);
                        const result = rawList.map((item) => ({ raw: item }));

                        callback({
                            recordsTotal: res?.count ?? result.length,
                            recordsFiltered: res?.count ?? result.length,
                            data: result
                        });
                    },
                    error: function(err) {
                        toast.error(err.statusText || 'Failed to load preseason contracts', {position: "top-right", autoClose: 5000});
                        callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
                    }
                });
            },
            columns: [
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" }
            ],
            columnDefs: [
                {
                    render: function(data) {
                        return (data?.company_pacra_id ?? data?.company ?? '—');
                    },
                    targets: 0
                },
                {
                    render: function(data) {
                        const statusMap = {
                            draft: '<span class="badge bg-secondary text-white">Draft</span>',
                            open: '<span class="badge bg-success text-white">Open</span>',
                            closed: '<span class="badge bg-dark text-white">Closed</span>'
                        };
                        return statusMap[data?.status] ?? (data?.status ?? '—');
                    },
                    targets: 1
                },
                {
                    render: function(data) {
                        return data?.total_quantity_kg != null ? Number(data.total_quantity_kg).toLocaleString() : '—';
                    },
                    targets: 2
                },
                {
                    render: function(data) {
                        return (data?.delivery_location) ?? '—';
                    },
                    targets: 3
                },
                {
                    render: function(data) {
                        return data?.application_deadline ? moment(data.application_deadline).format("Do MMM, YYYY") : '—';
                    },
                    targets: 4
                },
                {
                    render: function(data) {
                        return data?.date_created ? moment(data.date_created).format("Do MMM, YYYY") : '—';
                    },
                    targets: 5
                },
                {
                    render: function(data) {
                        return `<a href="#" class="nav-link view_contract"><i class="fa fa-eye"></i> View contract</a>`;
                    },
                    targets: 6
                }
            ]
        });

        table.on('click', '.view_contract', function(e) {
            e.preventDefault();
            let rowData = table.row($(this).closest('tr')).data();
            if (rowData && rowData.raw && rowData.raw.id) {
                props.history.push(`/preseason_contract/${rowData.raw.id}`);
            }
            return false;
        });
    }, [props.history, token]);

    const reloadTable = () => {
        if ($.fn.DataTable.isDataTable('#preseason_contract_table')) {
            $('#preseason_contract_table').DataTable().ajax.reload(null, false);
        }
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Preseason Contracts</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Preseason Contracts</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Preseason Contracts</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="preseason_contract_table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th className="wd-12p">Company</th>
                                            <th className="wd-10p">Status</th>
                                            <th className="wd-10p">Total (kg)</th>
                                            <th className="wd-18p">Delivery Location</th>
                                            <th className="wd-12p">Application Deadline</th>
                                            <th className="wd-12p">Date Created</th>
                                            <th className="wd-12p">Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreSeasonContract;
